import { categories } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const iconStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-800",
];

export default function Categories() {
  return (
    <section id="topics" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="找话题 · 按板块入座"
          title="话题分类，想吃哪块先选哪块"
          desc="六大常设板块覆盖大部分吃瓜场景。选一个感兴趣的板块，快速定位到与你同频的那群瓜友。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <a
              key={c.name}
              href="#news"
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200 hover:bg-background-100"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl ${iconStyles[i % iconStyles.length]}`}
                >
                  <i className={c.icon} aria-hidden="true"></i>
                </span>
                <i className="ri-arrow-right-up-line text-xl text-foreground-300 transition-colors group-hover:text-primary-500" aria-hidden="true"></i>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-600">{c.count}</span>
                <span className="inline-flex items-center whitespace-nowrap text-sm font-medium text-primary-600">
                  进板块
                  <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}